module.exports = __webpack_public_path__ + "static/media/ispe.c9f3c5e1.jpg";